// extracted by mini-css-extract-plugin
module.exports = {"devButton":"donations_devButton__2fd5q"};